import { SessionOverrides } from '@/utils/queryParams';

export interface ServiceConfig {
  baseUrl: string;
  subscriptionKey?: string;
}

export function createServiceConfig(overrides?: SessionOverrides): ServiceConfig {
  const envSubscriptionKey = process.env.VUE_APP_SUBSCRIPTION_KEY;
  const subscriptionKey = overrides?.subscriptionKey || envSubscriptionKey;
  const apiUrl = process.env.VUE_APP_ABSTRACTION_API || '';
  
  // Normalize the base URL by removing trailing slash and adding the appropriate path
  const normalizedApiUrl = apiUrl.replace(/\/$/, '');
  const baseUrl = `${normalizedApiUrl}${apiUrl.includes("localhost") ? '' : '/tokenless'}`;

  return {
    baseUrl,
    subscriptionKey
  };
}